module.exports = __webpack_public_path__ + "static/media/syd-grids.40908874.svg";